import { Component, ElementRef, Input, NgModule } from '@angular/core';
import { create } from 'canvas-confetti';
import { CommonModule } from '@angular/common';
import { InViewportModule } from 'ng-in-viewport';

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-confetti.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxConfettiComponent = /** @class */ (function () {
    function NgxConfettiComponent(elementRef) {
        this.elementRef = elementRef;
        this.interval = 2000;
        this.stopped = true;
    }
    /**
     * @return {?}
     */
    NgxConfettiComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.canvasId = "canvasRef" + Math.random()
            .toString()
            .slice(0, 6)
            .replace('.', '');
    };
    /**
     * @return {?}
     */
    NgxConfettiComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} __0
     * @return {?}
     */
    NgxConfettiComponent.prototype.setItemVisibility = /**
     * @param {?} __0
     * @return {?}
     */
    function (_a) {
        var _this = this;
        var target = _a.target, visible = _a.visible;
        this.visible = visible;
        setTimeout((/**
         * @return {?}
         */
        function () {
            // this.stop();
            if (visible) {
                _this.canvas = (/** @type {?} */ (_this.elementRef.nativeElement.querySelector("#" + _this.canvasId)));
                if (!_this.canvas) {
                    return;
                }
                _this.confetti = create(_this.canvas, {
                    resize: true,
                    useWorker: _this.useWorker
                });
                _this.fire();
                if (_this.interval > 0) {
                    _this.start();
                }
            }
            else {
                setTimeout((/**
                 * @return {?}
                 */
                function () { return _this.stop(); }), 1000);
            }
        }), 100);
    };
    /**
     * @return {?}
     */
    NgxConfettiComponent.prototype.start = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.stopped = false;
        this.timer = window.setInterval((/**
         * @return {?}
         */
        function () { return _this.fire(); }), this.interval);
    };
    /**
     * @return {?}
     */
    NgxConfettiComponent.prototype.stop = /**
     * @return {?}
     */
    function () {
        this.stopped = true;
        window.clearInterval(this.timer);
    };
    /**
     * @return {?}
     */
    NgxConfettiComponent.prototype.fire = /**
     * @return {?}
     */
    function () {
        this.confetti(this.options);
    };
    NgxConfettiComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-confetti',
                    template: "\n        <!-- <div> -->\n        <canvas\n            inViewport\n            [inViewportOptions]=\"{ threshold: [0], partial: true }\"\n            (inViewportAction)=\"setItemVisibility($event)\"\n            *ngIf=\"visible || stopped\"\n            [id]=\"canvasId\"\n        >\n            <ng-content></ng-content>\n        </canvas>\n        <!-- </div> -->\n    ",
                    styles: ['canvas { position: absolute; width: 100%; height: 100%; }', 'div { height: 100%}']
                }] }
    ];
    /** @nocollapse */
    NgxConfettiComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    NgxConfettiComponent.propDecorators = {
        interval: [{ type: Input }],
        options: [{ type: Input }],
        useWorker: [{ type: Input }]
    };
    return NgxConfettiComponent;
}());
if (false) {
    /** @type {?} */
    NgxConfettiComponent.prototype.interval;
    /** @type {?} */
    NgxConfettiComponent.prototype.options;
    /** @type {?} */
    NgxConfettiComponent.prototype.useWorker;
    /** @type {?} */
    NgxConfettiComponent.prototype.confetti;
    /** @type {?} */
    NgxConfettiComponent.prototype.timer;
    /** @type {?} */
    NgxConfettiComponent.prototype.visible;
    /** @type {?} */
    NgxConfettiComponent.prototype.canvasId;
    /** @type {?} */
    NgxConfettiComponent.prototype.canvas;
    /** @type {?} */
    NgxConfettiComponent.prototype.stopped;
    /**
     * @type {?}
     * @private
     */
    NgxConfettiComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-confetti.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxConfettiModule = /** @class */ (function () {
    function NgxConfettiModule() {
    }
    NgxConfettiModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [NgxConfettiComponent],
                    imports: [CommonModule, InViewportModule],
                    exports: [NgxConfettiComponent]
                },] }
    ];
    return NgxConfettiModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-confetti.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxConfettiComponent, NgxConfettiModule };
//# sourceMappingURL=ngx-confetti.js.map
